<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Seguridad</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Accesos IP por Sucursal</span>
    </div>
  </div>
</div>

<div class="row row-sm">

  <!-- ===== PANEL IZQUIERDO: SUCURSALES ===== -->
  <div class="col-lg-4 col-xl-3 ip-panel-sucursales">
    <div class="card h-100">
      <div class="card-header ip-card-header">
        <i class="bi bi-building me-2"></i>Sucursales
      </div>
      <div class="card-body p-0">

        @if (cargando) {
          <div class="text-center py-4">
            <div class="spinner-grow spinner-grow-sm text-primary" role="status"></div>
            <p class="mt-2 mb-0 text-muted small">Cargando sucursales...</p>
          </div>
        }

        @if (!cargando) {
          <div class="sucursal-list">
            @for (s of sucursales; track s) {
              <button
                type="button"
                class="sucursal-item"
                [class.active]="selected?.COD_SURC === s.COD_SURC"
                (click)="seleccionar(s)">
                <div class="sucursal-info">
                  <i class="bi bi-geo-alt-fill sucursal-icon"></i>
                  <span class="sucursal-nombre">{{ s.DIR_SURC }}</span>
                </div>
                <span class="ip-badge" [class.ip-badge--empty]="s.ips.length === 0">
                  {{ s.ips.length }} IP{{ s.ips.length !== 1 ? 's' : '' }}
                </span>
              </button>
            }
          </div>
        }

      </div>
    </div>
  </div>

  <!-- ===== PANEL DERECHO: GESTIÓN DE IPs ===== -->
  <div class="col-lg-8 col-xl-9">

    <!-- Estado vacío: sin selección -->
    @if (!selected && !cargando) {
      <div class="card empty-panel">
        <div class="card-body d-flex flex-column align-items-center justify-content-center py-5">
          <div class="empty-icon"><i class="bi bi-shield-lock"></i></div>
          <h6 class="mt-3 mb-1">Selecciona una sucursal</h6>
          <p class="text-muted small mb-0">Las IPs autorizadas aparecerán aquí.</p>
        </div>
      </div>
    }

    <!-- Panel de gestión -->
    @if (selected) {
      <div class="card">
        <div class="card-header ip-card-header d-flex align-items-center justify-content-between">
          <span><i class="bi bi-shield-check me-2"></i>{{ selected.DIR_SURC }}</span>
          <span class="badge bg-white text-primary fw-semibold">{{ selected.ips.length }} IP{{ selected.ips.length !== 1 ? 's' : '' }} registrada{{ selected.ips.length !== 1 ? 's' : '' }}</span>
        </div>
        <div class="card-body">
          <!-- Fila de ingreso rápido -->
          <div class="add-ip-row">
            <div class="add-ip-input-wrap">
              <i class="bi bi-ethernet add-ip-icon"></i>
              <input
                type="text"
                inputmode="decimal"
                class="form-control add-ip-input"
                placeholder="Ej: 192.168.1.100"
                [(ngModel)]="nuevaIp"
                (input)="fixIpInput($event)"
                (keydown.enter)="onEnter($event)"
                [disabled]="guardando"
                maxlength="15"
                autocomplete="off">
            </div>
            <button
              type="button"
              class="btn btn-primary btn-agregar"
              (click)="agregar()"
              [disabled]="!nuevaIp.trim() || guardando">
              @if (!guardando) {
                <span><i class="bi bi-plus-lg me-1"></i>Agregar</span>
              }
              @if (guardando) {
                <span><span class="spinner-border spinner-border-sm me-1"></span>Guardando...</span>
              }
            </button>
          </div>
          <p class="add-ip-hint">Presiona <kbd>Enter</kbd> para agregar rápidamente.</p>
          <!-- Lista de IPs -->
          @if (selected.ips.length === 0) {
            <div class="ip-empty-state">
              <i class="bi bi-shield-exclamation"></i>
              <span>Sin IPs registradas para esta sucursal.</span>
            </div>
          }
          @if (selected.ips.length > 0) {
            <div class="ip-grid">
              @for (ip of selected.ips; track ip) {
                <div class="ip-chip">
                  <div class="ip-chip-main">
                    <i class="bi bi-hdd-network-fill ip-chip-icon"></i>
                    <span class="ip-chip-address">{{ ip.direcionIp }}</span>
                  </div>
                  @if (ip.fechaAcceso) {
                    <div class="ip-chip-meta">
                      <i class="bi bi-clock me-1"></i>{{ ip.fechaAcceso }}
                    </div>
                  }
                  <button
                    type="button"
                    class="ip-chip-remove"
                    (click)="eliminar(ip)"
                    [disabled]="guardando"
                    title="Eliminar IP">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

  </div>
</div>
